/**
 * We know the specific components are located at these paths, which
 * can also be viewed like an article at the url, so we want to make sure
 * when doing an embed of the electorate components, that we strip the
 * whole web page and JUST show the components on the embed
 */
export function isElection(link: string) {
    return isFederalElection(link) || isStateElection(link)
}
// private functions for the above function and below styled component
export function isFederalElection(link: string) {
    return link.includes('embeds://elections-electorate/federal/')
}
export function isStateElection(link: string) {
    return link.includes('embeds://elections-electorate/state/')
}

export type ElectionType =
    | 'federal'
    | 'state-wa'
    | 'state-qld'
    | 'state-nsw'
    | 'state-vic'
    | 'state-sa'
    | 'state-tas'
    | 'state-nt'
    | 'state-act'
export interface ElectorateEmbedData {
    type: ElectionType
    electorate: string
    year: number
}
export function getElectorateData(link: string): ElectorateEmbedData {
    const trimmedString = link.replace('embeds://elections-electorate/', '')
    const split = trimmedString.split('/')

    try {
        let nextIndex = 1
        const rawElectionType = split[0]
        let electionType: ElectionType

        if (rawElectionType === 'state') {
            electionType = `state-${split[1].toLowerCase()}` as ElectionType
            nextIndex = 2
        } else {
            electionType = 'federal'
        }

        const year = Number(split[nextIndex++])
        const electorate = split[nextIndex++]

        return {
            type: electionType,
            year,
            electorate,
        }
    } catch (_) {
        throw new Error(
            `Invalid electorate link: ${link}, refer to the documentation for the correct format`,
        )
    }
}

//
